import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { DashboardTemplateResponse } from "../../models/DashboardTemplateResponse";
import DashboardView from "../DashboardView/DashboardView.vue";
import DashboardGridLayout from "../DashboardView/DashboardGridLayout/DashboardGridLayout .vue";

@Component({
  name: "DashboardPreview",
  components: {
    DashboardView,
    DashboardGridLayout
  }
})
export default class DashboardPreview extends Vue {
  @Prop() realDashboard?: boolean;
  @Prop() dashboardTemplate?: DashboardTemplateResponse;
  saveLayout = false;
  @Emit("close")
  onClose() {
    return;
  }
}
